import { addMonths, endOfMonth, format, parse, startOfMonth } from "date-fns";
import React, { useCallback, useState } from "react";
import { Input } from "../../components/weui";

const dayOne = startOfMonth(Date.now());
const maxDate = endOfMonth(Date.now());

export const DateSelector = (props) => {
  const [date, setDate] = useState(new Date());

  const changeDate = useCallback((dt) => {
    if (dt > maxDate) return;
    setDate(dt);
    if (typeof props.onChange === "function") {
      props.onChange(dt);
    }
  }, [setDate, props]);

  const stepDate = useCallback(step => {
    const dt = addMonths(date, step);
    changeDate(dt);
  }, [date, changeDate]);

  return (
    <>
      <div className="w-10/12 flex mAuto items-center">
        <i className="iconfont icon-zuozuo textBlue text-2xl"
          onClick={ e => stepDate(-1) } onKeyDown={ e => stepDate(-1) } role="button" tabIndex={ 0 }></i>
        <Input className="textBlue text-center h-10 inputBg mx-5 rounded-lg"
          type="month"
          value={ format(date, "yyyy-MM") }
          max={ format(maxDate, "yyyy-MM") }
          onChange={ e => {
            const dt = parse(e.target.value, "yyyy-MM", dayOne);
            changeDate(dt);
          } }
        />
        <i className="iconfont icon-you textBlue text-2xl"
          onClick={ e => stepDate(1) } onKeyDown={ e => stepDate(1) } role="button" tabIndex={ 0 }></i>
      </div>
    </>
  );
};
